import { useEffect } from 'react';
import { Button } from '@mui/material';
import eventBus, { eventBusValues } from '../../eventBus';
import { useAccount } from '../../contexts/Account';
import { ReactComponent as LinkedInIcon } from '../../icons/linkedin.svg';

function ShareBoardroomInLinkedIn({ text, buttonStyles = {}, company }) {
  const { isFreeTrial } = useAccount();

  const handleLinkedInShare = () => {
    if (isFreeTrial) {
      eventBus.dispatch(eventBusValues.triggerAdvisorUpgradeAction, {
        origin: 'share-linkedin',
      });
      return;
    }

    eventBus.dispatch('openLinkedInPostModal', {
      companyName: company?.displayName,
      linkedInPostTitle: "I've joined the {{Company}} Advisory Board!",
      postBody:
        "I'm now an advisor for the {{Company}} advisory board on @advisorycloud.",
      descriptionText:
        "We've made it easy to announce your new advisory board role on LinkedIn, so your colleagues and contacts celebrate your new milestone. Simply click Share on LinkedIn below.",
      customSuccessMessage:
        'Your advisory board announcement was shared successfully.',
    });
  };

  return (
    <Button
      onClick={handleLinkedInShare}
      variant="contained"
      color="primary"
      startIcon={<LinkedInIcon />}
      sx={{
        fontWeight: 600,
        fontSize: 14,
        textTransform: 'none',
        borderRadius: '8px',
        padding: '5px 20px',
        boxShadow: 'none',
        color: '#FFF',
        ...buttonStyles,
      }}
    >
      {text || 'Share on LinkedIn'}
    </Button>
  );
}

export default ShareBoardroomInLinkedIn;
